import React from 'react';
import { PageIntro } from '../components/PageIntro';
import { PricingPlans } from '../components/pricing/PricingPlans';
import { AddOnsGrid } from '../components/pricing/AddOnsGrid';
import { PageDefinitionBox } from '../components/pricing/PageDefinitionBox';
import { ComparisonTable } from '../components/pricing/ComparisonTable';
import { PaymentTerms } from '../components/pricing/PaymentTerms';
import { PricingFaq } from '../components/pricing/PricingFaq';
import { PricingClosingImage } from '../components/pricing/PricingClosingImage';
import { CtaBand } from '../components/home/CtaBand';
import { pricingHeroImage } from '../data/pricingImages';
export function Pricing() {
  return <>
      <PageIntro eyebrow="Pricing" title="Clear pricing. No surprises." lede="Every plan carries the same full service stack. The main variable is how many pages you need, and you will know the number before the first call ends." image={{
      src: pricingHeroImage.image,
      alt: pricingHeroImage.alt
    }} imageBackdrop data-id="element-1001" data-mp="3cag5qqqo1ssp" />
      <PricingPlans data-id="element-1002" data-mp="1eo1cj720cict" />
      <AddOnsGrid data-id="element-1003" data-mp="1jl1dx4nwwwxl" />
      <PageDefinitionBox data-id="element-1004" data-mp="1jlkqe5usmt48" />
      <ComparisonTable data-id="element-1005" data-mp="1jlt0xr3g1mc9" />
      <PaymentTerms data-id="element-1006" data-mp="1jiyfpxclvxhs" />
      <PricingFaq data-id="element-1007" data-mp="14nsc1h0zgarm" />
      <PricingClosingImage data-id="element-1008" data-mp="14oacyqylbd5v" />
      <CtaBand data-id="element-1009" data-mp="14p28y2w3ncwo" />
    </>;
}